module.exports = __webpack_public_path__ + "img/yuan-1.36da584d.png";